import { NextSeo } from 'next-seo';
import Head from 'next/head';
import { DataInsights } from '/screens/';

export default function DataInsightsPage() {
  return (
    <>
      <Head>
        <meta
          name="keywords"
          content="freight data insights, logistics data, freight operations"
        />
      </Head>
      <NextSeo
        nofollow={process.env.NOINDEX_FLAG}
        noindex={process.env.NOINDEX_FLAG}
        title="Freight Data Insights | Logistics Technology | Loadsmart"
        description="Gain visibility into your freight operations and optimize shipments based on lead time, detention, modes, and more."
        canonical="https://loadsmart.com/data-insights/"
        openGraph={{
          url: 'https://loadsmart.com/data-insights/',
        }}
      />
      <DataInsights />
    </>
  );
}
